module.exports = __webpack_public_path__ + "img/accordion-mask-string-ties-hero.b932b2f2.jpg";